import React from 'react';
import { GBTypography } from '@leapfinance/geebee-component-library';
import Close from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import startCase from 'lodash/startCase';
import { breakCamelCase, breakSnakeCase } from '../helpers';
var KeyValueDisplayModal = function (_a) {
    var _b;
    var data = _a.data, _c = _a.title, title = _c === void 0 ? 'CAS filling Details' : _c, onClose = _a.onClose;
    var formatValue = function (value) {
        if (Array.isArray(value)) {
            return value.join(', ');
        }
        switch (typeof value) {
            case 'boolean':
                return value ? 'Yes' : 'No';
            case 'string':
                return startCase(breakSnakeCase(value).toLowerCase());
            default:
                return value;
        }
    };
    var rows = (_b = Object.keys(data || {})) === null || _b === void 0 ? void 0 : _b.map(function (key) {
        return {
            name: key,
            value: data[key]
        };
    });
    return (React.createElement("div", { className: "lfc-flex lfc-items-center lfc-justify-center lfc-w-full lfc-h-full" },
        React.createElement("div", { className: "lfc-w-[45%] lfc-bg-white-0 lfc-rounded-md" },
            React.createElement("div", { className: "lfc-flex lfc-justify-between lfc-items-center lfc-bg-blue-100 lfc-font-bold lfc-rounded-t lfc-h-14 lfc-p-4" },
                React.createElement(GBTypography, { variant: "sh1" },
                    " ",
                    title),
                React.createElement(IconButton, { onClick: onClose },
                    React.createElement(Close, null))),
            React.createElement(TableContainer, { component: Paper, className: "lfc-max-h-[75vh] lfc-overflow-auto" },
                React.createElement(Table, { "aria-label": "simple table" },
                    React.createElement("colgroup", null,
                        React.createElement("col", { className: "lfc-w-1/3" }),
                        React.createElement("col", { className: "lfc-w-2/3" })),
                    React.createElement(TableBody, null, rows.map(function (row) { return (React.createElement(TableRow, { key: row.name, sx: { '&:last-child td, &:last-child th': { border: 0 } } },
                        React.createElement(TableCell, { component: "th", scope: "row" },
                            React.createElement(GBTypography, { variant: "body4" }, startCase(breakCamelCase(row.name).toLowerCase()))),
                        React.createElement(TableCell, { align: "right" },
                            React.createElement(GBTypography, { variant: "body4" },
                                " ",
                                formatValue(row.value))))); })))))));
};
export default KeyValueDisplayModal;
//# sourceMappingURL=KeyValueDisplayModal.js.map